//
// const BASE_URL = 'http://localhost:5000';
const BASE_URL = 'https://api.neoform.neolink.link';

export default BASE_URL;
